export const OCI_MIGRATION_DOCS_URL =
  'https://docs.sevalla.com/service-information/oci-migration#migration-to-oracle-cloud-infrastructure'

export const OKE_APP_EGRESS_IPS = {
  'ap-hyderabad-1-001': '129.225.75.32',
  'ap-mumbai-1-001': '132.226.186.203',
  'ap-seoul-1-001': '193.122.108.213',
  'ap-singapore-1-001': '138.2.83.4',
  'ap-sydney-1-001': '159.13.61.164',
  'ap-tokyo-1-001': '161.33.193.212',
  'ca-montreal-1-001': '148.116.79.221',
  'eu-amsterdam-1-001': '158.178.149.238',
  'eu-frankfurt-1-001': '141.147.20.167',
  'eu-madrid-1-001': '51.170.38.207',
  'eu-stockholm-1-001': '82.70.55.241',
  'eu-zurich-1-001': '140.86.210.127',
  'me-dubai-1-001': '84.235.254.148',
  'sa-santiago-1-001': '155.181.184.31',
  'sa-saopaulo-1-001': '136.248.122.39',
  'uk-london-1-001': '141.147.93.96',
  'us-ashburn-1-001': '129.80.131.65',
  'us-chicago-1-001': '147.224.148.77',
  'us-phoenix-1-001': '137.131.0.170',
  'us-sanjose-1-001': '146.235.209.187',
} as const satisfies Record<string, string>

export type OkeClusterName = keyof typeof OKE_APP_EGRESS_IPS

export const OKE_CLUSTER_LABELS: Record<OkeClusterName, string> = {
  'ap-hyderabad-1-001': 'Hyderabad, India',
  'ap-mumbai-1-001': 'Mumbai, India',
  'ap-seoul-1-001': 'Seoul, South Korea',
  'ap-singapore-1-001': 'Singapore',
  'ap-sydney-1-001': 'Sydney, Australia',
  'ap-tokyo-1-001': 'Tokyo, Japan',
  'ca-montreal-1-001': 'Montréal, Canada',
  'eu-amsterdam-1-001': 'Amsterdam, Netherlands',
  'eu-frankfurt-1-001': 'Frankfurt, Germany',
  'eu-madrid-1-001': 'Madrid, Spain',
  'eu-stockholm-1-001': 'Stockholm, Sweden',
  'eu-zurich-1-001': 'Zurich, Switzerland',
  'me-dubai-1-001': 'Dubai, UAE',
  'sa-santiago-1-001': 'Santiago, Chile',
  'sa-saopaulo-1-001': 'São Paulo, Brazil',
  'uk-london-1-001': 'London, United Kingdom',
  'us-ashburn-1-001': 'Ashburn, United States',
  'us-chicago-1-001': 'Chicago, United States',
  'us-phoenix-1-001': 'Phoenix, United States',
  'us-sanjose-1-001': 'San Jose, United States',
}

export const GCP_TO_OKE_CLUSTER = {
  // Relocating per docs.sevalla.com/service-information/oci-migration
  'asia-east1-001': 'ap-seoul-1-001',
  'asia-east2-001': 'ap-seoul-1-001',
  'asia-northeast2-001': 'ap-tokyo-1-001',
  'asia-south2-001': 'ap-hyderabad-1-001',
  'europe-north1-001': 'eu-stockholm-1-001',
  'europe-west1-001': 'eu-amsterdam-1-001',
  'europe-west4-001': 'eu-amsterdam-1-001',
  'us-central1-002': 'us-chicago-1-001',
  'us-east1-001': 'us-ashburn-1-001',
  'us-west1-001': 'us-sanjose-1-001',
  'us-west2-001': 'us-sanjose-1-001',
  'us-west3-001': 'us-phoenix-1-001',
  'us-west4-001': 'us-phoenix-1-001',
  // Same city on both providers
  'asia-northeast1-001': 'ap-tokyo-1-001',
  'asia-northeast3-001': 'ap-seoul-1-001',
  'asia-south1-001': 'ap-mumbai-1-001',
  'asia-southeast1-001': 'ap-singapore-1-001',
  'australia-southeast1-002': 'ap-sydney-1-001',
  'europe-west2-001': 'uk-london-1-001',
  'europe-west3-002': 'eu-frankfurt-1-001',
  'europe-west6-001': 'eu-zurich-1-001',
  'northamerica-northeast1-001': 'ca-montreal-1-001',
  'southamerica-east1-001': 'sa-saopaulo-1-001',
  'southamerica-west1-001': 'sa-santiago-1-001',
  'us-east4-001': 'us-ashburn-1-001',
} as const satisfies Record<string, OkeClusterName>

export type GcpClusterName = keyof typeof GCP_TO_OKE_CLUSTER

const isGcpClusterName = (name: string): name is GcpClusterName =>
  name in GCP_TO_OKE_CLUSTER

export type OciMigrationTarget = {
  okeCluster: OkeClusterName
  label: string
  appEgressIp: string
}

export const getOciMigrationTarget = (
  gcpCluster: string
): OciMigrationTarget | null => {
  if (!isGcpClusterName(gcpCluster)) {
    return null
  }
  const okeCluster = GCP_TO_OKE_CLUSTER[gcpCluster]
  return {
    okeCluster,
    label: OKE_CLUSTER_LABELS[okeCluster],
    appEgressIp: OKE_APP_EGRESS_IPS[okeCluster],
  }
}
